<template>
  <div class="_1">
    <h4>近期工单动态</h4>

    <div class="_2" v-for="each in ticketEventList" :key="each.id">
      <span class="_gray">{{each.createdAt}}</span>

      <span class="_gray">用户</span>

      <TicketUser :userId="each.dealUserId"/>

      <TicketOrigin v-model="each.originId"/>

      <span class="_gray">在工单</span>

      <TicketTitle :ticketTitle="each.ticketTitle" :ticketNo="each.orderId" />

      <span>{{each.operateContent}}</span>

      <!-- 回复 -->
      <span v-if="each.orderRemark"
        class="ticket-remark-content-summary">{{each.orderRemark.contentSummary}}</span>

      <!-- 指派 -->
      <span v-if="each.assignUserId">
        给
        <TicketUser :userId="each.assignUserId"/>
      </span>

      <span v-if="'创建' === each.operateContent"
        class="ticket-remark-content-summary">{{each.ticketContentSummary || '没有描述'}}</span>
    </div>

    <el-pagination
      style="padding-top:20px;"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :pager-count="9"
      :current-page="page.pageNumber" 
      :page-sizes="[10, 25, 50, 100]" 
      :page-size="page.pageSize" 
      :total="page.recordCount || 0" 
      @size-change="handleSizeChange" 
      @current-change="listTicketEvent" />
  </div>
</template>

<script>
export default {
  name: 'RecentTicketEvent',

  props : [ 'scope' ],

  data() {
    return {
      page : {
        pageNumber: 1,
        pageSize: 25,
        orderBy: "`flow_id` DESC"
      },

      ticketEventList: []
    };
  },

  watch : {
    '$route' : function() {
      this.listTicketEvent(1);
    }
  },

  methods : {
    handleSizeChange( pageSize ) {
      this.page.pageSize = pageSize;
      this.listTicketEvent();
    },

    listTicketEvent( _pageNumber ) {
      var _fun = 'all' == this.scope ? sdk.TicketEventApi().list : sdk.TicketEventApi().listMyTicketEvent;

      var _this = this;
      _this.page.pageNumber = _pageNumber;

      _fun({
        page : _this.page
      }).then( page => {
        this.ticketEventList = page.list;
        this.page.recordCount = page.recordCount;
      });
    }
  },

  mounted() {
    this.listTicketEvent();
  }
};
</script>

<style scoped>
.ticket-remark-content-summary {
  color: #3a6484;
}

._1 {
  border-left: 3px solid #f5f6fb;
  min-height: calc(100vh - 61px);
  padding: 20px;
}

._gray {
  color: DarkGray;
}

._2 {
  padding:10px 0;
  border-bottom:1px solid Gainsboro;
}

._2:hover {
  box-shadow: 1px 1px 20px 2px #e6e9da;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/RecentTicketEvent.vue